module.exports = __webpack_public_path__ + "static/seedstars-academy-ed9ff4c88436b6a171c20f860523fe0b.png";